export const branches = {
  "data": [
          {
            "SOL_ID": "0000",
            "DEL_FLG": "N",
            "SOL_DESC": "DATA CENTRE"
          },
          {
            "SOL_ID": "0001",
            "DEL_FLG": "N",
            "SOL_DESC": "NDEEBA"
          },
          {
            "SOL_ID": "0002",
            "DEL_FLG": "N",
            "SOL_DESC": "WANDEGEYA"
          },
          {
            "SOL_ID": "0003",
            "DEL_FLG": "N",
            "SOL_DESC": "WILLIAM STREET"
          },
          {
            "SOL_ID": "0005",
            "DEL_FLG": "N",
            "SOL_DESC": "BUGOLOBI"
          },
          {
            "SOL_ID": "0006",
            "DEL_FLG": "N",
            "SOL_DESC": "ENTEBBE"
          },
          {
            "SOL_ID": "0007",
            "DEL_FLG": "N",
            "SOL_DESC": "HOIMA"
          },
          {
            "SOL_ID": "0008",
            "DEL_FLG": "N",
            "SOL_DESC": "GULU"
          },
          {
            "SOL_ID": "0009",
            "DEL_FLG": "N",
            "SOL_DESC": "ARUA"
          },
          {
            "SOL_ID": "0011",
            "DEL_FLG": "N",
            "SOL_DESC": "SOROTI"
          },
          {
            "SOL_ID": "0012",
            "DEL_FLG": "N",
            "SOL_DESC": "LIRA"
          },
          {
            "SOL_ID": "0013",
            "DEL_FLG": "N",
            "SOL_DESC": "JINJA"
          },
          {
            "SOL_ID": "0014",
            "DEL_FLG": "N",
            "SOL_DESC": "FORT PORTAL"
          },
          {
            "SOL_ID": "0015",
            "DEL_FLG": "N",
            "SOL_DESC": "MASAKA"
          },
          {
            "SOL_ID": "0016",
            "DEL_FLG": "N",
            "SOL_DESC": "KABALE"
          },
          {
            "SOL_ID": "0017",
            "DEL_FLG": "N",
            "SOL_DESC": "MASINDI"
          },
          {
            "SOL_ID": "0019",
            "DEL_FLG": "N",
            "SOL_DESC": "LACOR"
          },
          {
            "SOL_ID": "0021",
            "DEL_FLG": "Y",
            "SOL_DESC": "MOBILE UNIT 1 -EASTERN REGION"
          },
          {
            "SOL_ID": "0022",
            "DEL_FLG": "N",
            "SOL_DESC": "MOBILE UNIT 2 - EASTERN REGION"
          },
          {
            "SOL_ID": "0023",
            "DEL_FLG": "N",
            "SOL_DESC": "MOBILE UNIT 1 - WESTERN REGION"
          },
          {
            "SOL_ID": "0024",
            "DEL_FLG": "N",
            "SOL_DESC": "MOBILE UNIT 1 - EASTERN REGION"
          },
          {
            "SOL_ID": "0025",
            "DEL_FLG": "N",
            "SOL_DESC": "KAMPALA ROAD"
          },
          {
            "SOL_ID": "0026",
            "DEL_FLG": "N",
            "SOL_DESC": "KAKIRI"
          },
          {
            "SOL_ID": "0027",
            "DEL_FLG": "N",
            "SOL_DESC": "IGANGA"
          },
          {
            "SOL_ID": "0028",
            "DEL_FLG": "N",
            "SOL_DESC": "NAKASONGOLA"
          },
          {
            "SOL_ID": "0029",
            "DEL_FLG": "N",
            "SOL_DESC": "KITGUM"
          },
          {
            "SOL_ID": "0031",
            "DEL_FLG": "N",
            "SOL_DESC": "KASESE"
          },
          {
            "SOL_ID": "0032",
            "DEL_FLG": "N",
            "SOL_DESC": "KAMWENGE BRANCH"
          },
          {
            "SOL_ID": "0033",
            "DEL_FLG": "N",
            "SOL_DESC": "NTUNGAMO"
          },
          {
            "SOL_ID": "0034",
            "DEL_FLG": "N",
            "SOL_DESC": "KANUNGU"
          },
          {
            "SOL_ID": "0035",
            "DEL_FLG": "N",
            "SOL_DESC": "MOBILE EAST 3 - SOROTI"
          },
          {
            "SOL_ID": "0036",
            "DEL_FLG": "N",
            "SOL_DESC": "MOBILE NORTH 1 - ARUA"
          },
          {
            "SOL_ID": "0037",
            "DEL_FLG": "N",
            "SOL_DESC": "SUMMIT"
          },
          {
            "SOL_ID": "0038",
            "DEL_FLG": "N",
            "SOL_DESC": "AMOLATAR"
          },
          {
            "SOL_ID": "0039",
            "DEL_FLG": "N",
            "SOL_DESC": "USAFI"
          },
          {
            "SOL_ID": "0041",
            "DEL_FLG": "N",
            "SOL_DESC": "LAMWO"
          },
          {
            "SOL_ID": "0042",
            "DEL_FLG": "N",
            "SOL_DESC": "KAPCHORWA"
          },
          {
            "SOL_ID": "0043",
            "DEL_FLG": "N",
            "SOL_DESC": "ANAKA"
          },
          {
            "SOL_ID": "0068",
            "DEL_FLG": "N",
            "SOL_DESC": "FOREST MALL BRANCH"
          },
          {
            "SOL_ID": "0065",
            "DEL_FLG": "N",
            "SOL_DESC": "RUSHERE BRANCH"
          },
          {
            "SOL_ID": "0044",
            "DEL_FLG": "N",
            "SOL_DESC": "MOBILE UNIT-HOIMA"
          },
          {
            "SOL_ID": "0045",
            "DEL_FLG": "N",
            "SOL_DESC": "BWEYALE"
          },
          {
            "SOL_ID": "0046",
            "DEL_FLG": "N",
            "SOL_DESC": "MOBILE-LIRA"
          },
          {
            "SOL_ID": "0047",
            "DEL_FLG": "N",
            "SOL_DESC": "MAKERERE UNIVERSITY"
          },
          {
            "SOL_ID": "0048",
            "DEL_FLG": "N",
            "SOL_DESC": "BISHOP STUART UNIVERSITY"
          },
          {
            "SOL_ID": "0049",
            "DEL_FLG": "N",
            "SOL_DESC": "PACKWACH"
          },
          {
            "SOL_ID": "0051",
            "DEL_FLG": "N",
            "SOL_DESC": "KAYUNGA"
          },
          {
            "SOL_ID": "0052",
            "DEL_FLG": "N",
            "SOL_DESC": "BOMBO"
          },
          {
            "SOL_ID": "0053",
            "DEL_FLG": "N",
            "SOL_DESC": "MUBENDE"
          },
          {
            "SOL_ID": "0054",
            "DEL_FLG": "N",
            "SOL_DESC": "MOROTO BRANCH"
          },
          {
            "SOL_ID": "0055",
            "DEL_FLG": "N",
            "SOL_DESC": "BUKEDEA BRANCH"
          },
          {
            "SOL_ID": "0056",
            "DEL_FLG": "N",
            "SOL_DESC": "MOBILE MUBENDE"
          },
          {
            "SOL_ID": "0057",
            "DEL_FLG": "N",
            "SOL_DESC": "MOBILE MOROTO"
          },
          {
            "SOL_ID": "0058",
            "DEL_FLG": "N",
            "SOL_DESC": "KOTIDO BRANCH"
          },
          {
            "SOL_ID": "0059",
            "DEL_FLG": "N",
            "SOL_DESC": "KAGADI BRANCH"
          },
          {
            "SOL_ID": "0061",
            "DEL_FLG": "N",
            "SOL_DESC": "YUMBE BRANCH"
          },
          {
            "SOL_ID": "0062",
            "DEL_FLG": "N",
            "SOL_DESC": "MBARARA MOBILE"
          },
          {
            "SOL_ID": "0063",
            "DEL_FLG": "N",
            "SOL_DESC": "GULU MOBILE"
          },
          {
            "SOL_ID": "0064",
            "DEL_FLG": "N",
            "SOL_DESC": "MUKONO BRANCH"
          },
          {
            "SOL_ID": 2101,
            "DEL_FLG": "N",
            "SOL_DESC": "MBARARA"
          },
          {
            "SOL_ID": 2201,
            "DEL_FLG": "N",
            "SOL_DESC": "MBALE"
          },
          {
            "SOL_ID": "HOD",
            "DEL_FLG": "N",
            "SOL_DESC": "HEAD OFFICE"
          },
          {
            "SOL_ID": "MAIN",
            "DEL_FLG": "N",
            "SOL_DESC": "CITY BRANCH"
          },
          {
            "SOL_ID": "SACCO",
            "DEL_FLG": "N",
            "SOL_DESC": "MFS - HEAD QUARTERS"
          }
  ]
}

